import { render } from "./worm-squirm.vue?vue&type=template&id=3695ecae&scoped=true"
import script from "./worm-squirm.vue?vue&type=script&lang=js"
export * from "./worm-squirm.vue?vue&type=script&lang=js"

import "./worm-squirm.vue?vue&type=style&index=0&id=3695ecae&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3695ecae"]])

export default __exports__